/* src/app/shared/components/not-found/not-found.component.scss */
.not_found_container h1 {
  color: var(--text-color);
  animation: text-load 0.8s forwards ease-in;
}
@keyframes text-load {
  from {
    font-size: 0rem;
  }
  to {
    font-size: 15rem;
  }
}
.not_found_container .person_background {
  border-radius: 100%;
  position: relative;
  background-color: #e0e0e0;
  box-shadow:
    0px 4px 10px rgba(0, 0, 0, 0.03),
    0px 0px 2px rgba(0, 0, 0, 0.06),
    0px 2px 6px rgba(0, 0, 0, 0.12);
  animation: enlarge 0.6s 0.3s forwards ease-in;
  overflow: hidden;
}
@keyframes enlarge {
  from {
    width: 0rem;
    height: 0rem;
  }
  to {
    width: 11rem;
    height: 11rem;
  }
}
.not_found_container .person {
  position: absolute;
  top: 1.4rem;
  opacity: 0;
  animation: lookFastPause 8s 1s infinite;
  transform-origin: center;
}
@keyframes lookFastPause {
  0% {
    opacity: 0;
    transform: translateY(2rem);
  }
  10% {
    opacity: 1;
    transform: translateY(0);
  }
  20% {
    transform: rotateY(-180deg);
  }
  30% {
    transform: rotateY(-180deg);
  }
  40% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(0);
  }
  60% {
    transform: rotateY(-180deg);
  }
  70% {
    transform: rotateY(-180deg);
  }
  80% {
    opacity: 1;
    transform: translateY(0rem);
  }
  100% {
    opacity: 0;
    transform: translateY(2rem);
  }
}
/*# sourceMappingURL=not-found.component.css.map */
